import * as LoanFormatActionsTypes from './types';
import { LoanFormatAction } from './types';
import { LOANFORMAT_ALL_OBJECT } from './actions';
import { LoanFormatState } from './state';
import { LocationChangeAction } from 'connected-react-router';

export default function loanFormatReducer(
    state: LoanFormatState = LOANFORMAT_ALL_OBJECT,
    action: LoanFormatAction | LocationChangeAction
): LoanFormatState {
    switch (action.type) {
        case LoanFormatActionsTypes.LOANFORMAT_CHANGE:
            return { ...action.payload };
        default:
            return state;
    }
}
